import { FC } from 'react';
import { PayCircleOutlined } from '@ant-design/icons';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 结算按钮 */
const SettlementButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

SettlementButton.defaultProps = {
  icon: ICON_COLLECTION.SETTLEMENT,
  text: '结算',
};

export default SettlementButton;
